import React, {Component} from "react"
import {RouteComponentProps} from "react-router-dom"
import PropTypes from "prop-types"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import loginService from "@irati/auth/services/login"

type logoutProp = () => Promise<any>
type clearWalletProps = () => Promise<any>

interface Props extends RouteComponentProps {
  logout: logoutProp,
  clearWallet: clearWalletProps
}

interface State {
  load: Promise<any>
}

export class Logout extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  state: State = {
    load: hangPromise()
  }

  componentDidMount() {
    this.setState({load: loginService.logout()})
  }

  render() {
    return <Loading load={this.state.load} />
  }
}

export default Logout
